import React, { useState, useMemo, useEffect } from 'react';
import { Row, Col, Typography } from 'antd';
import { GoLocation, GoStar } from 'react-icons/go';
import {
  CenterProps,
  calcCrow,
} from '../../dashboard/components/DesktopMealCarousel';
import { usePosition } from 'use-position';
import { useSelector } from 'react-redux';
import { getUserState } from '../../../store/user/selector';

export interface ProfileDetailsProps {
  details: any;
}

export const ProfileDetails: React.FC<ProfileDetailsProps> = ({ details }) => {
  const { user, ratings } = useSelector(getUserState);
  const [cooksLocation, setCooksLocation] = useState<CenterProps>();
  const settings = useMemo(
    () => ({ enableHighAccuracy: true, timeout: 0, maximumAge: Infinity }),
    []
  );

  const watch = true;
  const { latitude, longitude } = usePosition(watch, settings);

  const cookLocation = () => {
    if (details) {
      setCooksLocation({ ...details?.location });
    }
  };

  useEffect(cookLocation, [details]);
  const checklength = ratings.filter(item => item.user === details.id);
  const rate = ratings
    .filter(v => v.user === details.id)
    .reduce((a, b) => a + b.rate / checklength.length, 0);

  return (
    <div className="profile-cover-image">
      <div
        style={{
          backgroundImage: `url(${details.image})`,
        }}
        className="profile-image"
      />
      <Row className="profile-icon-container" justify="space-between">
        <Row className="icon-container">
          {user.accountType === 'i offer' ? null : (
            <div>
              <GoLocation color="#B0B1B2" size={15} />
              <Typography.Text className="kilometer-text">
                {' '}
                {calcCrow(
                  cooksLocation?.lat,
                  cooksLocation?.lng,
                  latitude,
                  longitude
                ).toFixed(2)}{' '}
                km
              </Typography.Text>
            </div>
          )}
        </Row>
        <Row className="icon-container">
          <GoStar color="#F7C82E" size={14} style={{ marginRight: 5 }} />

          <Typography.Text className="rate-text">
            {rate !== 0 ? rate : 'No Ratings'}
          </Typography.Text>
        </Row>
      </Row>
      <Col className="description-container">
        <Typography.Text className="title-text">
          {details.firstName}
        </Typography.Text>
        <Typography.Paragraph
          className="description-text"
          ellipsis={{ rows: 3 }}
        >
          {details.description}
        </Typography.Paragraph>
      </Col>
    </div>
  );
};
